var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _path9, _path0, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 483.26 163.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f15a29;}.cls-2,.cls-3{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#f15a29;stroke-width:9px;}.cls-3{stroke:#fff;stroke-width:0.75px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,167.74V102.07a43.28,43.28,0,0,1,5.9-1q3.23-.33,6.34-.48c2.08-.09,3.92-.14,5.52-.14a33.33,33.33,0,0,1,13.77,2.5,18.14,18.14,0,0,1,8.36,7.2,22.19,22.19,0,0,1,2.83,11.61q0,11-6.53,16.56t-19,5.52H17.66v23.91Zm10.65-33h6.53q7.3,0,11-3t3.7-9.8q0-6.24-3.46-9.21t-9.6-3c-1.4,0-2.91,0-4.51,0a29.12,29.12,0,0,0-3.65.24Z",
    transform: "translate(-7.01 -6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.35,167.74V102.17a38.17,38.17,0,0,1,5.43-1.06c2-.25,4-.43,6-.53s3.73-.14,5.14-.14q11.72,0,18.19,5.33t6.48,16a19.84,19.84,0,0,1-2.93,10.75,19.34,19.34,0,0,1-8.4,7.3q2.31,3.45,5,8.11t5.38,9.79q2.64,5.15,4.75,10H102.14q-1.92-4.8-4.17-9.36c-1.51-3-3.07-5.94-4.71-8.69s-3.25-5.25-4.84-7.49H79v25.54ZM79,133.37h4.61a26.55,26.55,0,0,0,8.25-1.11A9.63,9.63,0,0,0,97,128.57a12.27,12.27,0,0,0,1.77-7A12.39,12.39,0,0,0,97,114.41a9.53,9.53,0,0,0-4.8-3.6,20,20,0,0,0-6.67-1.06c-1.22,0-2.44,0-3.65,0A19.18,19.18,0,0,0,79,110Z",
    transform: "translate(-7.01 -6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.54,167.74V101.21h38.59V110H144.19v18.24h24.39v8.93H144.19V158.9h30.24v8.84Z",
    transform: "translate(-7.01 -6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.65,169.18a27.46,27.46,0,0,1-14.74-3.89,25.59,25.59,0,0,1-9.79-11.62q-3.51-7.72-3.5-19.25,0-11.22,3.84-19a28,28,0,0,1,10.36-11.76,27.12,27.12,0,0,1,14.5-4,31.08,31.08,0,0,1,6.53.67,33.33,33.33,0,0,1,5.61,1.73,31.26,31.26,0,0,1,4.56,2.31l-3,8.54a30.68,30.68,0,0,0-6.58-2.83,24.78,24.78,0,0,0-7.05-1,15.92,15.92,0,0,0-9.17,2.78,18.41,18.41,0,0,0-6.43,8.4,36.26,36.26,0,0,0-2.36,14,40.32,40.32,0,0,0,2.16,14.16,17.38,17.38,0,0,0,6.34,8.55,17.15,17.15,0,0,0,9.84,2.83,29.22,29.22,0,0,0,7.39-.91,25.89,25.89,0,0,0,6.43-2.64l2.69,8.54a29.09,29.09,0,0,1-7.77,3.22A38.9,38.9,0,0,1,219.65,169.18Z",
    transform: "translate(-7.01 -6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.68,167.74v-25q-6.24-10.67-11.23-20.79t-9-20.78H263a173.62,173.62,0,0,0,6.43,16.61q3.64,8.16,7.68,16,1.92-3.65,3.84-7.73t3.74-8.3c1.22-2.82,2.36-5.63,3.41-8.45s2.07-5.54,3-8.16H302.5q-4,10.65-8.93,20.64t-11.24,20.73v25.16Z",
    transform: "translate(-7.01 -6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318,167.74v-6.53q2.88-6,6.43-12.24t7.35-12.77q3.78-6.48,7.87-13.06t8.3-13.1H319.39v-8.83h41.09V109q-3.08,4.51-6.34,9.56t-6.52,10.27q-3.27,5.24-6.34,10.41t-5.9,10.18q-2.83,5-5.24,9.5h31.2v8.84Z",
    transform: "translate(-7.01 -6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.21,169.18a31.92,31.92,0,0,1-7.78-.87,27.93,27.93,0,0,1-6-2.16,27.26,27.26,0,0,1-4.18-2.54l4.13-8.64a43.78,43.78,0,0,0,5.67,3.31,16.28,16.28,0,0,0,7.39,1.68q6.24,0,9.55-3.36t3.31-11.42V110H387.74v-8.83H421V146a31.6,31.6,0,0,1-2.07,11.62,17,17,0,0,1-7.05,8.4Q406.85,169.18,398.21,169.18Z",
    transform: "translate(-7.01 -6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.43,167.74q2.11-8.16,4.42-16.71t4.84-17.09q2.55-8.53,5.19-16.8t5.52-15.93h12.29q2.78,7.68,5.47,16t5.13,16.9q2.46,8.54,4.71,17t4.27,16.56H478.94l-3.65-16.52H452.93l-3.56,16.52Zm16.7-25.35h18.05q-1.24-5.76-2.73-11.23t-3.08-10.56q-1.58-5.09-3.12-9.6-1.53,4.6-3.12,9.74t-3.07,10.52Q456.58,136.63,455.13,142.39Z",
    transform: "translate(-7.01 -6)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.96,
    y1: 82,
    x2: 237.71,
    y2: 4.23
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.15,7.81",
    transform: "translate(-7.01 -6)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M435.83,83.9",
    transform: "translate(-7.01 -6)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 431.65,
    y1: 81.72,
    x2: 234.49,
    y2: 4.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d9424c2710acbc5b622ecb5c0377ea10.svg";
export { ForwardRef as ReactComponent };